import { useEffect } from "react";
import { useNavigate, useParams, useSearchParams, useLocation } from "react-router-dom";
import { setHousehold, setHomeHousehold } from "../lib/household";
import { setSessionHeader } from "../context/SecurityContext";
import { NoIndex } from "../components/Seo";

// /h/<slug>?next=/vault#t=<token> — enter an advisor-managed household, then continue.
export default function EnterHousehold() {
  const { slug } = useParams();
  const [params] = useSearchParams();
  const { hash } = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    setHousehold(slug === "primary" ? "" : slug);
    if (slug === "primary") setHomeHousehold("");
    localStorage.removeItem("hv_last_member");
    const token = new URLSearchParams(hash.replace(/^#/, "")).get("t");
    if (token) setSessionHeader(token);
    const next = params.get("next") || "/vault";
    const gmail = params.get("gmail");
    navigate(next.startsWith("/") ? `${next}${gmail ? `${next.includes("?") ? "&" : "?"}gmail=${gmail}` : ""}` : "/vault", { replace: true });
  }, [slug, params, hash, navigate]);
  return (
    <div className="min-h-screen grid place-items-center text-sm text-muted-foreground" data-testid="enter-household">
      <NoIndex title="Household" />
      Opening the vault…
    </div>
  );
}
